
import React, { useState, useEffect } from "react";
import ImagingHeader from "./ImagingHeader";
import ImagingNewHeader from "./ImagingNewHeader";
import TopNav from "../TopNav/TopNav";
import { FaArrowLeft } from "react-icons/fa";
import BookForm from "./BookForm";
import { Scroll } from "../Scroll function/scroll";
import { Link } from "react-router-dom";
import { BackToscreen } from "../New-Dashboard/Orders";
import { Warning, Regards } from "../Plan-detail/NewPlanComponent";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { AiFillPlusCircle } from "react-icons/ai";
import { getCartDetails,EmptyCart } from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import { connect } from "react-redux";
import metroCross from "../../Assets/metroCross.svg";
import { useHistory, useLocation } from "react-router";
import { Modal } from "react-responsive-modal";
// import "./Cart.css";
import Loader from "../Loader/Loader";
import ImagingPackageInfo from "./ImagingPackageInfo";
import { CLEAR_CENTERADDRESS } from "../../Redux/Constants";

export const FloatingButton = ({ amount }) => {
  return (
    <div className="mobileFooter">
      <p>
        Total Amount <br />
        <span style={{ fontWeight: "600" }}>Rs. {amount}/-</span>
      </p>
      <span className="add_tocart" style={{ borderRadius: "9px" }}>
        PROCEED
      </span>
    </div>
  );
};

export const AddMore = (citySelect) => {
  const history = useHistory();
  return (
    <div
      className=" vflex"
      onClick={() =>
        history.push(
          `/imaging/health-checkup-packages${
            citySelect.citySelect
              ? `-${citySelect.citySelect.toLowerCase().replace(" ", "-")}`
              : ""
          }`
        )
      }
    >
      <h5 className="note">Add More Test</h5>

      <AiFillPlusCircle />
    </div>
  );
};



export const BackToscreenIcon = ({ title, currpath }) => {
  return (
    <div className="currentWindow">
      <Link to={`/${currpath}`}>
        {/* <FaArrowLeft /> */}
        {title}
      </Link>
    </div>
  );
};

const BackToHomeNew = () => {
  setRemoveAllPackageModal(false);
  return (
    <div className="currentWindow">
      <Link to={`/`}>
        {/* <FaArrowLeft /> */}
        {/* {title} */}
      </Link>
    </div>
  );
};

export const DesktopBack = ({ title, currpath }) => {
  return (
    <div className="backIcon">
      <Link to={`/${currpath}`}>
        {/* <FaArrowLeft /> */}
        {title}
      </Link>
    </div>
  );
};
function ImagingCart(props) {

  const [removeAllPackageModal, setRemoveAllPackageModal] = useState(false)

  const dispatch = useDispatch();
  const history = useHistory();

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  const currentcity = citySelected.citySelect;
  const cartDetails = useSelector((state) => state.CartReducer);

  const { loading, cartDetails: cartdata } = cartDetails;

  useEffect(() => {
    Scroll();
  });

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));
    var token = userFromLocal.token;

    dispatch(getCartDetails(token, currentcity, CenterAddress?.id));
  }, []);


  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal?.token;
    cartDetails?.cartDetails && cartDetails?.cartDetails[0]?.product?.forEach(item => {
      if (item?.package?.org_type == "homedx") {
        setRemoveAllPackageModal(true)
        props.EmptyCart(token)
        setTimeout(() => {
          props.getCart(token)
        }, 500);
        return
      }
    })
  }, [])

  const BackToHomeNew = () => {
    setRemoveAllPackageModal(false);
    // history.push("/");
    window.location.href = process.env.RAZZLE_APP_BASE_URL
    
  };



  return (
    <>
      <ImagingNewHeader />

      <BackToscreenIcon title="My Cart" currpath="cart" />
      <div className="container">
        <DesktopBack title="My Cart" currpath="imaging/cart" />
      </div>

      <div className="cart ctop">
        {/** SHOW THIS DIV IF CART IS EMPTY */}
        {loading ? (
          <Loader />
        ) : cartDetails &&
          cartDetails.cartDetails &&
          cartDetails.cartDetails[0] &&
          cartDetails.cartDetails[0].product.length > 0 ? (
          /** SHOW THIS DIV IF CART IS NOT EMPTY */

          <div className="cart_main">
            {console.log("cart array", cartDetails.cartDetails[0].product)}
            <div className="cart_leftSide">
              {/* <div className="box paddng_2">
                <span>Selected </span>
                <span>
                  Redcliffe labs Diagnostics Pvt. Ltd. Noida Sector-62
                </span>
              </div> */}
              {/**Package info component */}
              {cartDetails &&
                cartDetails.cartDetails &&
                cartDetails.cartDetails[0] &&
                cartDetails.cartDetails[0].product.length > 0 &&
                cartDetails.cartDetails[0].product.map((values) => {
                  return (
                    <ImagingPackageInfo key={values.id} cartData={values} />
                  );
                })}

              {/***Add more div */}
              <AddMore citySelect={citySelect} />
              {/* <Warning desc="Do not eat or drink anything (except water) 8-10 hours before test" /> */}
              {/* <Regards /> */}
            </div>
            <div className="cart_RightSide">
              <BookForm
                imagineCart={true}
                empty={false}
                details={cartDetails.cartDetails[0].product}
              />
            </div>

            {/**MOBILE FOOTER */}
          </div>
        ) : (
          <div className="cartDiv">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/dc2c4338-9b68-4b36-9c43-2969dca2665a.svg"
              alt="cart_img"
              width="100%"
            />
            <div className="cartDesc">
              <h2 className="cartHeading">Your Cart is Empty! {}</h2>
              <p className="font_2rem cartmsg">
                There are no items in your cart. Explore and add packages!
              </p>
              <Link
                to={`/imaging/health-checkup-packages${
                  citySelect
                    ? `-${citySelect.toLowerCase().replace(" ", "-")}`
                    : ""
                }`}
              >
                <span className="exploreBtn">EXPLORE PACKAGES</span>
              </Link>
            </div>
          </div>
        )}
      </div>
      <Modal
        open={removeAllPackageModal}
        onClose={()=>{setRemoveAllPackageModal(false)}}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div onClick={()=>{setRemoveAllPackageModal(false)}} className="modalCloseButton" >
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <h2>Your cart has been cleared.</h2>
          <h2>Both Pathology and Radiology package's can not be added in a single cart</h2>
          <div className="modal-inner">
             {/* <a href={process.env.RAZZLE_APP_BASE_URL} className="modal-link" onClick={onCloseModal}>
              No
            </a> */}
            <button className="modal-link" onClick={BackToHomeNew}>
              OK{" "}
            </button>
          </div>
        </div>
      </Modal>

      {/* <ImagingFooter
        telNumber="898 898 0101"
      /> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  // AddonState: state?.AddonSetter?.Addon,
});

const mapDispatchToProps = (dispatch) => {
  return {
    EmptyCart: (token) => {
      dispatch(EmptyCart(token));
    },
    getCart: (token) => {
      dispatch(getCartDetails(token));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(ImagingCart)),
};

